import { createSlice } from '@reduxjs/toolkit';
import { CARD_INTERNAL_KEYS } from '../../../sections/constants';
const defaultSettings = [];
const initialState = {
  settings: defaultSettings,
  draftSettings: defaultSettings
};
export const sectionSettingsSlice = createSlice({
  name: 'sectionSettings',
  initialState,
  reducers: {
    resetDraftSettings(state) {
      state.draftSettings = state.settings;
    },
    updateDraftSetting(state, action) {
      state.draftSettings = state.draftSettings.map(setting => {
        if (setting.sectionKey === action.payload.sectionKey) {
          return Object.assign({}, setting, action.payload);
        }
        return setting;
      });
    },
    updateDraftSettingOrders(state, action) {
      // Createt a map of key values to easily update the draft order
      const draftSettingsMap = state.draftSettings.reduce((acc, item) => {
        acc[item.sectionKey] = item;
        return acc;
      }, {});

      //force internal keys to be included
      //place them at the end of the array
      const mergedKeys = [...action.payload, ...CARD_INTERNAL_KEYS];
      state.draftSettings = mergedKeys.map(item => draftSettingsMap[item]).filter(setting => setting !== undefined);
    },
    addSection(state, action) {
      const {
        sectionKey,
        defaultSetting
      } = action.payload;
      const newDraftSettings = state.draftSettings || [];
      const savedSetting = state.settings.find(item => item.sectionKey === sectionKey);
      const sectionDefaultSetting = defaultSetting === null || defaultSetting === void 0 ? void 0 : defaultSetting.settings;
      state.draftSettings = [...newDraftSettings, {
        sectionKey,
        settings: (savedSetting === null || savedSetting === void 0 ? void 0 : savedSetting.settings) || sectionDefaultSetting
      }];
    },
    removeSection(state, action) {
      state.draftSettings = state.draftSettings.filter(setting => setting.sectionKey !== action.payload);
    },
    updateSettings(state, action) {
      const newSettings = action.payload;
      // Update settings
      state.settings = newSettings;
      if (!state.draftSettings.length) {
        // Initializing of draftSettings
        state.draftSettings = newSettings;
      } else {
        // Updating draftSettings when cache.modify is called with settings changes
        const settingsMap = newSettings.reduce((acc, item) => {
          acc[item.sectionKey] = item;
          return acc;
        }, {});
        // Apply any reordering/adding/removing of sections
        // Keep any unsaved new sections in store from previous draft settings
        state.draftSettings = state.draftSettings.map(item => {
          if (settingsMap[item.sectionKey]) {
            return settingsMap[item.sectionKey];
          }
          return item;
        }).filter(setting => setting !== undefined);
      }
    },
    clearDraftAndSavedSettings(state) {
      state.draftSettings = defaultSettings;
      state.settings = defaultSettings;
    }
  }
});
export const {
  resetDraftSettings,
  updateDraftSetting,
  updateDraftSettingOrders,
  updateSettings,
  addSection,
  removeSection,
  clearDraftAndSavedSettings
} = sectionSettingsSlice.actions;